import React from "react";

interface HeaderContentProps {
	label: string;
	value: string | React.ReactNode;
}

export const HeaderContent = ({ label, value }: HeaderContentProps) => {
	return <>
		<span className="text-gray-500">{label}</span>{" "}
		<span className="font-medium">{value}</span>
	</>;
}